/**
 * The routes of Docs › Team setup (ADR-217 §2.4), mounted by App.tsx inside
 * the standards layout and rendered as they are by the tests. The tab is in
 * the path (`/docs/team-setup/<tab>`, Skills by default). Docs › Skills'
 * address opens the Skills tab; a skill's page, its comparison and its editor
 * (ADR-216 and its Amendment 1) keep their addresses.
 */
import { Navigate, Route, useLocation } from 'react-router-dom';
import { SkillDetailPage } from './SkillsTab';
import { SkillComparePage } from './SkillCompare';
import { SkillEditPage } from './SkillEditor';
import TeamSetupPage from './TeamSetupPage';
import { TEAM_SETUP_PATH } from './teamSetup';

/** The Skills tab, the query string and hash kept. */
function ToSkillsTab() {
  const { search, hash } = useLocation();
  return <Navigate to={`${TEAM_SETUP_PATH}/skills${search}${hash}`} replace />;
}

export function teamSetupRoutes() {
  return (
    <>
      <Route path="docs/team-setup" element={<ToSkillsTab />} />
      <Route path="docs/team-setup/:tab" element={<TeamSetupPage />} />
      <Route path="docs/skills" element={<ToSkillsTab />} />
      <Route path="docs/skills/:name" element={<SkillDetailPage />} />
      <Route path="docs/skills/:name/compare" element={<SkillComparePage />} />
      <Route path="docs/skills/:name/edit" element={<SkillEditPage />} />
    </>
  );
}
